import { useState } from 'react';
import type { ReactNode } from 'react';
import { SlidePane } from './SlidePane';

interface Props {
  animated?: boolean;
}

interface SlidePaneHook {
  closePane: () => void;
  openPane: (paneContent: ReactNode) => void;
  pane: ReactNode;
}

export const useSlidePane = (props?: Props): SlidePaneHook => {
  const animated = !!props?.animated;
  const [open, setOpen] = useState<boolean>(false);
  const [content, setContent] = useState<ReactNode>(null);

  const openPane = (paneContent: ReactNode) => {
    setContent(paneContent);

    setOpen(true);
  };

  const closePane = () => {
    setOpen(false);

    if (animated) {
      // clear content after animation
      setTimeout(() => {
        setContent(null);
      }, 400);
    } else {
      setContent(null);
    }
  };

  return {
    closePane,
    openPane,
    pane:
      animated || open ? (
        <SlidePane open={open} animated={animated}>
          {content}
        </SlidePane>
      ) : null,
  };
};
